export const CAMPAIGN_STATUS = Object.freeze({
    DELETED: 0,
    ACTIVE: 1,
    SCHEDULED: 4,
    FINISHED: 5
});

export const CAMPAIGN_STATUS_LABEL = Object.freeze({
    [CAMPAIGN_STATUS.ACTIVE]:    "Activo",
    [CAMPAIGN_STATUS.SCHEDULED]: "Programado",
    [CAMPAIGN_STATUS.FINISHED]:  "Finalizado",
    [CAMPAIGN_STATUS.DELETED]:   "Eliminado"
});

export function getCampaignStatusOptions() {
    return [
        { value: CAMPAIGN_STATUS.ACTIVE,    label: CAMPAIGN_STATUS_LABEL[CAMPAIGN_STATUS.ACTIVE] },
        { value: CAMPAIGN_STATUS.SCHEDULED, label: CAMPAIGN_STATUS_LABEL[CAMPAIGN_STATUS.SCHEDULED] },
        { value: CAMPAIGN_STATUS.FINISHED,  label: CAMPAIGN_STATUS_LABEL[CAMPAIGN_STATUS.FINISHED] },
        { value: CAMPAIGN_STATUS.DELETED,   label: CAMPAIGN_STATUS_LABEL[CAMPAIGN_STATUS.DELETED] }
    ];
}
export const PLAYER_STATUS = Object.freeze({
    DELETED: 0,
    ACTIVE: 1,
    COMPLETED: 2,
    EXPIRED: 3,
    SCHEDULED: 4
});
export const isCampaignImmutable = (s) =>
    Number(s) === CAMPAIGN_STATUS.DELETED || Number(s) === CAMPAIGN_STATUS.FINISHED;
export const isPlayerImmutable = (s) =>
    Number(s) === PLAYER_STATUS.DELETED ||
    Number(s) === PLAYER_STATUS.COMPLETED ||
    Number(s) === PLAYER_STATUS.EXPIRED;

export function computeCampaignStatus(baseStatus, startMs, endMs) {
    const base = Number(baseStatus ?? CAMPAIGN_STATUS.SCHEDULED);
    if (isCampaignImmutable(base)) return base;
    const now = Date.now();
    if (endMs && now >= endMs) return CAMPAIGN_STATUS.FINISHED;
    if (startMs && now < startMs) return CAMPAIGN_STATUS.SCHEDULED;
    return CAMPAIGN_STATUS.ACTIVE;
}
export function desiredPlayerStatusFor(campaignEffective, playerCurrent) {
    const cur = Number(playerCurrent ?? PLAYER_STATUS.SCHEDULED);
    if (isPlayerImmutable(cur)) return cur;
    const c = Number(campaignEffective);
    if (c === CAMPAIGN_STATUS.SCHEDULED) return PLAYER_STATUS.SCHEDULED;
    if (c === CAMPAIGN_STATUS.ACTIVE)    return PLAYER_STATUS.ACTIVE;
    if (c === CAMPAIGN_STATUS.FINISHED)  return PLAYER_STATUS.EXPIRED;
    if (c === CAMPAIGN_STATUS.DELETED)   return PLAYER_STATUS.DELETED;
    return cur;
}

export function planActionsForCampaign(row) {
    const startMs = row?.startDate ? new Date(row.startDate).getTime() : (row?.startTime || 0);
    const endMs   = row?.endDate   ? new Date(row.endDate).getTime()   : 0;

    const baseStatus = Number(row?.baseStatus ?? row?.campaignStatus ?? CAMPAIGN_STATUS.SCHEDULED);
    const effective  = computeCampaignStatus(baseStatus, startMs, endMs);

    const plan = {
        effectiveCampaignStatus: effective,
        campaignUpdate: null,
        playerUpdates: [],
        providerDeletes: []
    };

    if (!isCampaignImmutable(baseStatus) && baseStatus !== effective) {
        const id = String(row?.campaignId || '');
        if (id) plan.campaignUpdate = { campaignId: id, newStatus: effective };
    }
    const list = Array.isArray(row?.playerList) ? row.playerList : [];
    const isDeleted = (effective === CAMPAIGN_STATUS.DELETED);
    for (const p of list) {
        const cur = Number(p?.playerStatus ?? PLAYER_STATUS.SCHEDULED);
        const id  = String(p?.playerId ?? '');
        const bonus = p?.bonusCode || p?.deliveredPromos?.[0]?.bonusCode;

        if (isDeleted) {
            if (cur !== PLAYER_STATUS.COMPLETED) {
                plan.providerDeletes.push({ playerId: id, bonusCode: bonus, currentStatus: cur });
            }
            if (cur === PLAYER_STATUS.ACTIVE || cur === PLAYER_STATUS.SCHEDULED) {
                plan.playerUpdates.push({ playerId: id, bonusCode: bonus, newStatus: PLAYER_STATUS.DELETED });
            }
            continue;
        }
        const desired = desiredPlayerStatusFor(effective, cur);
        if (desired !== cur) {
            plan.playerUpdates.push({ playerId: id, bonusCode: bonus, newStatus: desired });
        }
    }
    return plan;
}
